<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/citybridge.jpg')"
    aspect-ratio="1.7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">About Exicon Investment Banking</h1>          
      </v-layout>
    </v-parallax>
    <v-layout row wrap
    text-xs-center
    justify-center>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin">Our Focus</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-5 font-weight-thin">To deliver success, we focus on markets, industries and deal-types that we know well.</h1>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://sociable.co/wp-content/uploads/2018/05/outsourcing-latin-america-1280x720.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">We focus on companies in Latin America.</div>
                <span class="grey--text">We focus on helping companies in South America and Caribbean access global capital resources.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUPfRF0HG4ySmMdtel5y74t6aBdbQKrwORbQ&usqp=CAU"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">We like industries with differentiated products.</div>
                <span class="grey--text">Such as manufacturing, consumer goods, distribution healthcare and financial services companies.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://www.thenakedheadhunter.com/wp-content/uploads/2017/04/boardroom-e1491318161397.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">We prefer companies with market leading positions.</div>
                <span class="grey--text">
                  We look for cash generative businesses with market leadership and above USD 25M in annual sales.
                </span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-2 font-weight-thin my-2">Our Team</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-5 font-weight-thin my-2">
            Benefit from our access to key investors in capital markets globally and our professional deal making experience.
          </h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-4 mx-2">
          <v-expansion-panel popout>
            <v-expansion-panel-content
              v-for="(member, i) in members"
              :key="i"
              hide-actions
            >
              <v-layout
                slot="header"
                align-center
                row
                spacer
              >
                <v-flex xs4 sm2 md1>
                  <v-avatar
                    slot="activator"
                    size="48px"
                  >
                    <img
                      v-if="member.avatar"
                      :src="require('@/assets/' + member.avatar + '.png')"
                      alt="Team Member"
                    >
                  </v-avatar>
                </v-flex>

                <v-flex sm5 md3 hidden-xs-only>
                  <strong v-html="member.name"></strong>
                </v-flex>

                <v-flex no-wrap xs5 sm3>
                  <span v-html="member.title"></span>
                </v-flex>

                <v-flex
                  v-if="member.excerpt"
                  class="grey--text"
                  ellipsis
                  hidden-sm-and-down
                >
                  &mdash;
                  {{ member.excerpt }}
                </v-flex>
              </v-layout>

              <v-card>
                <v-divider></v-divider>
                <v-card-text>
                  <span>{{member.content}}</span>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        members: [
          {
            avatar: 'mario',
            name: 'Mario Lizana-Allende',
            title: 'Managing Director',
            excerpt: 'Founded Exicon in 2003',
            content: 'Mario Lizana-Allende founded Exicon after having been Manager for Latin America and the Caribbean of KPMG LLP in Miami, United States. He brings with him years of corporate finance experience and relationships with the largest strategic and financial investors of the United States, Asia and Europe. Mario has a Degree in Law from the Complutense University of Madrid and a Master in Business Administration – MBA- degree from the Autonoma University of Madrid. He served as President of the Chile-US Chamber of Commerce in the United States and was Chairman of the Founding Committee of the Colombo Chilean Chamber of Commerce in Colombia. He speaks fluent in Spanish, German and English.'
          },
          {
            avatar: 'cecil',
            name: 'Cecil Yi Peng Ang',
            title: 'Director',
            excerpt: 'Joined Exicon 2016',
            content: 'Cecil Ang joined Exicon after founding Betafish Pte Ltd, a financial tech company in Singapore and Silicon Valley, CA, USA. Before Betafish, Cecil spent five years as a Senior Research Associate at Sands Capital Management LLC (USA), an investment company that manages more than USD 100B. Cecil graduated with the Highest Distinction in Economics and Finance from University of Virginia, USA and is a Chartered Financial Analyst Level III Candidate. He speaks fluent English, Mandarin and Spanish.'
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/info.vue